import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { api, storageUrl } from "../api";
import { formatPrice } from "../data/currency";
import { LibraryCardSkeleton } from "../components/Skeleton";

function WishlistPage({ onAction }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchWishlist = () => {
    api.get("/wishlist").then(setGames).finally(() => setLoading(false));
  };

  useEffect(() => { fetchWishlist(); }, []);

  const handleRemove = async (game) => {
    await api.delete(`/games/${game.id}/wishlist`);
    setGames((prev) => prev.filter((g) => g.id !== game.id));
    if (onAction) onAction();
  };

  if (loading) return (
    <div className="wishlist">
      <h2>My Wishlist</h2>
      <div className="wishlist-grid">
        {Array.from({ length: 3 }).map((_, i) => (
          <LibraryCardSkeleton key={i} />
        ))}
      </div>
    </div>
  );

  if (games.length === 0) {
    return (
      <div className="wishlist-empty">
        <h2>My Wishlist</h2>
        <p>You haven't added any games to your wishlist yet.</p>
        <Link to="/" className="browse-link">Browse Games</Link>
      </div>
    );
  }

  return (
    <div className="wishlist">
      <h2>My Wishlist ({games.length})</h2>
      <div className="wishlist-grid">
        {games.map((game) => {
          const cat = game.category;
          return (
            <div key={game.id} className="wishlist-card">
              <img src={storageUrl(game.thumbnail_path)} alt={game.title} />
              <div className="wishlist-card-body">
                <h3>{game.title}</h3>
                <span className="game-card-genre">{cat ? cat.name : ""}</span>
                <div className="wishlist-card-footer">
                  <span className="game-card-price">{formatPrice(game.price)}</span>
                  <button className="wishlist-remove-btn" onClick={() => handleRemove(game)}>
                    Remove
                  </button>
                </div>
                <Link to={`/game/${game.id}`} className="game-card-btn">View Details</Link>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default WishlistPage;
